module.exports = __webpack_public_path__ + "img/about_header.58cc7f42.png";